<div class="reset-password-area" [class.dark-theme]="themeService.isDark()">
    <div class="trezo-form mx-auto" [class.component-dark-theme]="themeService.isDark()" [class.component-rtl-enabled]="themeService.isRTLEnabled()">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 order-2 order-lg-1">
                <div class="form-image">
                    <img src="images/reset-password.jpg" alt="reset-password-image" />
                </div>
            </div>
            <div class="col-lg-6 col-md-12 order-1 order-lg-2">
                <div class="form-content">
                    <div class="logo">
                        <img src="images/logo/ALU FINAL LOGO-HORIZONTAL2.png" alt="logo" />
                        <img src="images/logo/ALU FINAL LOGO-HORIZONTAL2.png" class="d-none" alt="logo" />
                    </div>
                    <div class="title">
                        <h1 class="fw-semibold">Reset Password?</h1>
                        <p class="fw-medium">Enter your new password and confirm it another time in the field below.</p>
                    </div>
                    <form [formGroup]="frmResetPasswordForm" (ngSubmit)="onSubmit()">
                        <!-- <div class="form-group position-relative">
                            <label
                                class="main-label d-block fw-medium text-black"
                            >
                                Old Password
                            </label>
                            <input
                                [type]="
                                    isPassword1Visible ? 'text' : 'password'
                                "
                                [value]="password1"
                                (input)="onPassword1Input($event)"
                                class="form-control"
                                placeholder="Type password"
                            />
                            <button
                                type="button"
                                (click)="togglePassword1Visibility()"
                                class="icon-button p-0 border-0 bg-transparent transition"
                            >
                                <i
                                    [ngClass]="
                                        isPassword1Visible
                                            ? 'ri-eye-line'
                                            : 'ri-eye-off-line'
                                    "
                                ></i>
                            </button>
                        </div> -->
                        <div class="form-group position-relative">
                            <label class="main-label d-block fw-medium text-black">New Password</label>
                            <input [type]="isPassword2Visible ? 'text' : 'password'" placeholder="New Password" formControlName="newPasswordControl" maxlength="100" class="form-control" placeholder="Type password" />
                            <button type="button" (click)="togglePassword2Visibility()" class="icon-button p-0 border-0 bg-transparent transition">
                                <i [ngClass]="isPassword2Visible ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
                            </button>
                        </div>
                        <div class="form-text text-danger" *ngIf="f['newPasswordControl']!.hasError('required') && f['newPasswordControl']!.touched">
                            New Password is required.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['newPasswordControl']!.hasError('hasCharacters') && f['newPasswordControl']!.touched">
                            Minimum Password length should be 8 characters.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['newPasswordControl']!.hasError('hasUpper') && f['newPasswordControl']!.touched">
                            Password must contain at least one uppercase.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['newPasswordControl']!.hasError('hasLower') && f['newPasswordControl']!.touched">
                            Password must contain at least one lowercase.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['newPasswordControl']!.hasError('hasNumber') && f['newPasswordControl']!.touched">
                            Password must contain at least one number.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['newPasswordControl']!.hasError('hasSpecialChar') && f['newPasswordControl']!.touched">
                            Password must contain at least one special character.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['newPasswordControl']!.hasError('mustMatch') && f['newPasswordControl']!.touched">
                            Confirm Password must be match with password.
                        </div>
                        <div class="form-group position-relative">
                            <label class="main-label d-block fw-medium text-black">Confirm Password</label>
                            <input [type]="isPassword3Visible ? 'text' : 'password'" placeholder="Confirm Password" formControlName="confirmPasswordControl" maxlength="100" class="form-control" placeholder="Type password" />
                            <button type="button" (click)="togglePassword3Visibility()" class="icon-button p-0 border-0 bg-transparent transition">
                                <i [ngClass]="isPassword3Visible ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
                            </button>
                        </div>
                        <div class="form-text text-danger" *ngIf="f['confirmPasswordControl']!.hasError('required') && f['confirmPasswordControl']!.touched">
                            Confirm Password is required.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['confirmPasswordControl']!.hasError('hasCharacters') && f['confirmPasswordControl']!.touched">
                            Minimum Password length should be 8 characters.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['confirmPasswordControl']!.hasError('hasUpper') && f['confirmPasswordControl']!.touched">
                            Password must contain at least one uppercase.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['confirmPasswordControl']!.hasError('hasLower') && f['confirmPasswordControl']!.touched">
                            Password must contain at least one lowercase.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['confirmPasswordControl']!.hasError('hasNumber') && f['confirmPasswordControl']!.touched">
                            Password must contain at least one number.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['confirmPasswordControl']!.hasError('hasSpecialChar') && f['confirmPasswordControl']!.touched">
                            Password must contain at least one special character.
                        </div>
                        <div class="form-text text-danger" *ngIf="f['confirmPasswordControl']!.hasError('mustMatch') && f['confirmPasswordControl']!.touched">
                            Confirm Password must be match with password.
                        </div>
                        <button [disabled]="!formIsValid()" class="btn-box d-block w-100 border-0 transition fw-medium border-radius">
                            <span class="d-flex align-items-center justify-content-center">
                                <i class="material-symbols-outlined">autorenew</i>
                                Reset Password
                            </span>
                        </button>
                        <p class="info">
                            Back to
                            <a routerLink="/login" class="fw-semibold text-primary">Sign In</a>
                        </p>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>